<section class="outreach-selection" [attr.aria-busy]="loading">
 <h3 class="outreach-heading">{{ 'OUTREACH_FOR' | translate }}</h3>
 <p *ngIf="loading" role="status">{{ 'LOADING' | translate }}</p>
 <app-user-message *ngIf="error" type="error" [message]="'OUTREACH_LOAD_FAILED' | translate" [actionLabel]="'TRY_AGAIN' | translate" (action)="load()" [dismissible]="false"></app-user-message>
 <fieldset *ngIf="options" [disabled]="disabled || loading" class="outreach-fieldset">
  <label class="outreach-field">{{ 'OUTREACH_INCLUDE' | translate }}
   <select class="form-control" [ngModel]="scope" (ngModelChange)="setScope($event)" [ngModelOptions]="{standalone:true}" data-outreach-scope>
    <option value="member">{{ (seedMemberIds.length===1?'OUTREACH_MEMBER_ONLY':'OUTREACH_SELECTED_ONLY') | translate }}</option>
    <option value="primary">{{ 'OUTREACH_PRIMARY' | translate }}</option>
    <option value="all">{{ 'OUTREACH_ALL_HOUSEHOLDS' | translate }}</option>
    <option value="households">{{ 'OUTREACH_CHOOSE_HOUSEHOLDS' | translate }}</option>
    <option value="custom">{{ 'OUTREACH_CHOOSE_INDIVIDUALS' | translate }}</option>
   </select>
  </label>
  <ng-container *ngIf="scope==='households'">
   <label *ngFor="let h of options.households" class="outreach-household">
    <input type="checkbox" [checked]="householdIds.includes(h.id)" (change)="toggleHousehold(h.id,$any($event.target).checked)" [attr.data-household]="h.id">
    <span>{{ h.name ? ('OUTREACH_HOUSEHOLD_OF' | translate:{name:h.name}) : ('HOUSEHOLD' | translate) }}<small>{{ 'OUTREACH_MEMBERS_COUNT' | translate:{count:h.memberIds.length} }}</small></span>
   </label>
  </ng-container>
  <div class="outreach-actions" *ngIf="scope==='custom'">
   <button type="button" class="btn btn-outline-primary" (click)="selectAll()">{{ 'OUTREACH_SELECT_ALL' | translate }}</button>
   <button type="button" class="btn btn-outline-primary" (click)="clear()">{{ 'CLEAR' | translate }}</button>
  </div>
  <p class="outreach-selection-count" aria-live="polite">{{ 'OUTREACH_SELECTED_COUNT' | translate:{count:ids.length} }}</p>
  <ul class="outreach-people" *ngIf="scope==='custom'; else selectedPeople">
   <li *ngFor="let person of options.members"><label><input type="checkbox" [checked]="ids.includes(person.memberId)" (change)="togglePerson(person.memberId,$any($event.target).checked)" [attr.data-person]="person.memberId"><span>{{person.name}}</span></label></li>
  </ul>
  <ng-template #selectedPeople><ul class="outreach-people"><li *ngFor="let person of included">{{person.name}}</li></ul></ng-template>
  <p class="outreach-hint">{{ 'OUTREACH_SHARED_ONCE' | translate }}</p>
 </fieldset>
</section>
